// import request from '../liveRequest/request';
import { getJson ,post, deleteMethod} from '@/api/http';

/** 新增答题 */
// export const addAnswerSheetApi = (data) => {
//     return getJson({
//         url: `${config.cpp}handler/v1/answerSheet/add`,
//         method: 'POST',
//         data
//     });
// };
export const addAnswerSheetApi = (data,token)=>post(`${config.cpp}handler/v2/answerSheet/add`,data,{token})
/** 编辑答题 */
export const updateAnswerSheetApi = (data, token) => post(`${config.cpp}handler/v1/answerSheet/update`, data, {token})

export const getPaperInfo = (params,token) =>getJson(`${config.cpp}handler/v1/paper/info/id`,params,{token})
/** 获取答题卡列表 */
// export const getAnswerSheetList = (params) => {
//     return getJson({
//         url: `${config.cpp}handler/v2/answerSheet/webcast/list`,
//         method: 'GET',
//         params
//     });
// };
export const getAnswerSheetList = (params,token)=>getJson(`${config.cpp}handler/v2/answerSheet/webcast/list`,params,{token})

/** 获取答题卡详情 */
export const getwebcastAnswerSheet = (id,token)=>getJson(`${config.cpp}handler/v2/answerSheet/webcast/${id}`,null,{token})

/** 获取答题统计信息 */
export const getAnswerSheetId = (id,token)=>getJson(`${config.cpp}handler/v1/answerSheet/question/base_result/${id}`,null,{token})


// export const getAnswerSheetIdApi = (id) => {
//     return getJson({
//         url: `${config.cpp}handler/v1/answerSheet/question/base_result/${id}`,
//         method: 'GET'
//     });
// };


export const releaseAnswerSheet = (data,token) =>post(`${config.cpp}handler/v2/answerSheet/publish`,data,{token})

/** 结束发布答题 */
export const finishAnswerApi = (data,token) =>post(`${config.cpp}handler/v1/answerSheet/stopAnswer/${data.id}`,null,{token})

/** 删除问答题 */
// export const deletAnswerSheetApi = (id) => {
//     return deleteMethod({
//         url: `${config.cpp}handler/v1/answerSheet/question/${id}`,
//         method: 'delete'
//     });
// };
export const deletAnswerSheetApi = (id,token)=>deleteMethod(`${config.cpp}handler/v1/answerSheet/question/${id}`,{token})

/** 发送答题结果 */
export const sendQuestionResult = (id, token) => post(`${config.cpp}handler/v2/answerSheet/push/question/result/${id}`, null, {token})